import svgIcons from "../../../assets/svg/svgIcons";

export const ENABLE_MAP_CLUSTERING_OPTIONS = [
  { id: "Off", label: "Off", value: "0" },
  { id: "On", label: "On", value: "1" },
  { id: "Always", label: "Always show all pushpins", value: "2" },
];

export enum ACCOUNT_RECORDER_TYPE_VALUES {
  SURFSIGHT = "2",
  VISIONMAX = "3",
}

export const DEFAULT_RECORDER_TYPES = [
  { label: "FleetVision", value: ACCOUNT_RECORDER_TYPE_VALUES.VISIONMAX }, // VisionMax is called FleetVision in the UI
  { label: "SurfSight", value: ACCOUNT_RECORDER_TYPE_VALUES.SURFSIGHT },
];

export enum ACCOUNT_RECORDER_CONFIGURATION_VALUES {
  YES = "1",
  NO = "0",
}

export const ACCOUNT_RECORDER_CONFIGURATION_OPTIONS = [
  { label: "Yes", value: ACCOUNT_RECORDER_CONFIGURATION_VALUES.YES },
  { label: "No", value: ACCOUNT_RECORDER_CONFIGURATION_VALUES.NO },
];

export enum SPEED_UNITS {
  MPH = "MPH",
  KMH = "KMH",
  NAUTICAL_MILES = "NAUTICAL_MILES",
}

export enum SPEED_UNIT_VALUES {
  MPH = "0",
  KMH = "1",
  NAUTICAL_MILES = "2",
}

export const SPEED_UNITS_OPTIONS = [
  { label: "Mph", value: SPEED_UNIT_VALUES.MPH, unit: SPEED_UNITS.MPH },
  { label: "Km/h", value: SPEED_UNIT_VALUES.KMH, unit: SPEED_UNITS.KMH },
  {
    label: "Nautical Miles",
    value: SPEED_UNIT_VALUES.NAUTICAL_MILES,
    unit: SPEED_UNITS.NAUTICAL_MILES,
  },
];

export enum DISTANCE_UNIT_VALUES {
  MILES = "0",
  KM = "1",
  NAUTICAL_MILES = "2",
}

export enum DISTANCE_UNITS {
  MILES = "MILES",
  KM = "KM",
  NAUTICAL_MILES = "NAUTICAL_MILES",
}

export const DISTANCE_UNITS_OPTIONS = [
  {
    unit: DISTANCE_UNITS.MILES,
    label: "Miles",
    value: DISTANCE_UNIT_VALUES.MILES,
  },
  { unit: DISTANCE_UNITS.KM, label: "Km", value: DISTANCE_UNIT_VALUES.KM },
  {
    unit: DISTANCE_UNITS.NAUTICAL_MILES,
    label: "Nautical Miles",
    value: DISTANCE_UNIT_VALUES.NAUTICAL_MILES,
  },
];

export enum VOLUME_UNIT_VALUES {
  GALLONS = "0",
  LITERS = "1",
  IMPERIAL_GALLONS = "2",
  FT_3 = "3",
}

export enum VOLUME_UNITS {
  GALLONS = "GALLONS",
  LITERS = "LITERS",
  IMPERIAL_GALLONS = "IMPERIAL_GALLONS",
  FT_3 = "FT_3",
}
export enum ECONOMY_UNITS_VALUES {
  MPG = "0",
  KML = "1",
  KPG = "2",
  L_100KM = "3",
}
export enum ECONOMY_UNITS {
  MPG = "MPG",
  KML = "KML",
  KPG = "KPG",
  L_100KM = "L_100KM",
}
export enum PRESSURE_UNITS_VALUES {
  KPA = "0",
  PSI = "1",
  MMHG = "2",
  BAR = "3",
}
export enum PRESSURE_UNITS {
  KPA = "KPA",
  PSI = "PSI",
  MMHG = "MMHG",
  BAR = "BAR",
}
export enum C_TO_TEMPERATURE_UNITS_VALUES {
  FAHRENHEIT = "0",
  CELSIUS = "1",
}
export enum C_TO_TEMPERATURE_UNITS {
  FAHRENHEIT = "FAHRENHEIT",
  CELSIUS = "CELCIUS",
}

export const VOLUME_UNITS_OPTIONS = [
  {
    unit: VOLUME_UNITS.GALLONS,
    label: "Gallons",
    value: VOLUME_UNIT_VALUES.GALLONS,
  },
  {
    unit: VOLUME_UNITS.LITERS,
    label: "Liters",
    value: VOLUME_UNIT_VALUES.LITERS,
  },
  {
    unit: VOLUME_UNITS.IMPERIAL_GALLONS,
    label: "Imperial Gallons",
    value: VOLUME_UNIT_VALUES.IMPERIAL_GALLONS,
  },
  { unit: VOLUME_UNITS.FT_3, label: "ft³", value: VOLUME_UNIT_VALUES.FT_3 },
];

export const ECONOMY_UNITS_OPTIONS = [
  { unit: ECONOMY_UNITS.MPG, label: "mpg", value: ECONOMY_UNITS_VALUES.MPG },
  { unit: ECONOMY_UNITS.KML, label: "km/L", value: ECONOMY_UNITS_VALUES.KML },
  { unit: ECONOMY_UNITS.KPG, label: "kpg", value: ECONOMY_UNITS_VALUES.KPG },
  {
    unit: ECONOMY_UNITS.L_100KM,
    label: "L/100km",
    value: ECONOMY_UNITS_VALUES.L_100KM,
  },
];

export const PRESSURE_UNITS_OPTIONS = [
  { id: "KPA", label: "kPa", value: "0" },
  { id: "PSI", label: "psi", value: "1" },
  { id: "MMHG", label: "mmHg", value: "2" },
  { id: "BAR", label: "bar", value: "3" },
];

export const TEMPRATURE_UNITS_OPTIONS = [
  { id: "FAHRENHEIT", label: "Fahrenheit", value: "0" },
  { id: "CELSIUS", label: "Celsius", value: "1" },
];

export const LATITUDE_LONGITUDE_FORMAT_OPTIONS = [
  { id: "DEGREES", label: "Degrees", value: "0" },
  { id: "DEG_MIN_SEC", label: "Deg:Min:Sec", value: "1" },
  { id: "DEG_MIN", label: "Deg:Min", value: "2" },
];

export const ROUTE_LINE_THICKNESS_OPTIONS = [
  { id: "ONE", label: "1 (Thinnest)", value: "1" },
  { id: "TWO", label: "2 (Default)", value: "2" },
  { id: "THREE", label: "3", value: "3" },
  { id: "FOUR", label: "4", value: "4" },
  { id: "FIVE", label: "5", value: "5" },
  { id: "SIX", label: "6", value: "6" },
  { id: "SEVEN", label: "7", value: "7" },
  { id: "EIGHT", label: "8 (Widest)", value: "8" },
];

export const DEFAULT_OVERLAY_OPTIONS = [
  { id: "UNSPECIFIED", value: "Unspecified", label: "Unspecified" },
  // disabled 6/28 as these values should be received from DB
  // {"id": "SOONERSALOONWHITE", "value": "SoonerSaloonWhite", "label": "SoonerSaloonWhite"},
  // {"id": "SOONERSALOONTRANSPARENT", "value": "SoonerSaloonTransparent", "label": "SoonerSaloonTransparent"},
  // {"id": "VIRGINIA", "value": "Virginia", "label": "Virginia"},
  // {"id": "CLEVELANDPOLICEDISTRICT_1", "value": "ClevelandPoliceDistrict1", "label": "ClevelandPoliceDistrict1"},
  // {"id": "CLEVELANDPOLICEDISTRICT_2", "value": "ClevelandPoliceDistrict2", "label": "ClevelandPoliceDistrict2"},
  // {"id": "CLEVELANDPOLICEDISTRICT_3", "value": "ClevelandPoliceDistrict3", "label": "ClevelandPoliceDistrict3"},
  // {"id": "CLEVELANDPOLICEDISTRICT_4", "value": "ClevelandPoliceDistrict4", "label": "ClevelandPoliceDistrict4"},
  // {"id": "CLEVELANDPOLICEDISTRICT_5", "value": "ClevelandPoliceDistrict5", "label": "ClevelandPoliceDistrict5"},
  // {"id": "CLEVELANDWARD_1", "value": "ClevelandWard1", "label": "ClevelandWard1"},
  // {"id": "CLEVELANDWARD_2", "value": "ClevelandWard2", "label": "ClevelandWard2"},
  // {"id": "CLEVELANDWARD_3", "value": "ClevelandWard3", "label": "ClevelandWard3"},
  // {"id": "CLEVELANDWARD_4", "value": "ClevelandWard4", "label": "ClevelandWard4"},
  // {"id": "CLEVELANDWARD_5", "value": "ClevelandWard5", "label": "ClevelandWard5"},
  // {"id": "CLEVELANDWARD_6", "value": "ClevelandWard6", "label": "ClevelandWard6"},
  // {"id": "CLEVELANDWARD_7", "value": "ClevelandWard7", "label": "ClevelandWard7"},
  // {"id": "CLEVELANDWARD_8", "value": "ClevelandWard8", "label": "ClevelandWard8"},
  // {"id": "CLEVELANDWARD_9", "value": "ClevelandWard9", "label": "ClevelandWard9"},
  // {"id": "CLEVELANDWARD_10", "value": "ClevelandWard10", "label": "ClevelandWard10"},
  // {"id": "CLEVELANDWARD_11", "value": "ClevelandWard11", "label": "ClevelandWard11"},
  // {"id": "CLEVELANDWARD_12", "value": "ClevelandWard12", "label": "ClevelandWard12"},
  // {"id": "CLEVELANDWARD_13", "value": "ClevelandWard13", "label": "ClevelandWard13"},
  // {"id": "CLEVELANDWARD_14", "value": "ClevelandWard14", "label": "ClevelandWard14"},
  // {"id": "CLEVELANDWARD_15", "value": "ClevelandWard15", "label": "ClevelandWard15"},
  // {"id": "CLEVELANDWARD_16", "value": "ClevelandWard16", "label": "ClevelandWard16"},
  // {"id": "CLEVELANDWARD_17", "value": "ClevelandWard17", "label": "ClevelandWard17"},
  // {"id": "CLEVELANDWARD_18", "value": "ClevelandWard18", "label": "ClevelandWard18"},
  // {"id": "CLEVELANDWARD_19", "value": "ClevelandWard19", "label": "ClevelandWard19"}
];

export const SCORECARD_WEIGHT_FACTOR_OPTIONS = [
  { id: "0", label: "0", value: "0" },
  { id: "1", label: "1", value: "1" },
  { id: "2", label: "2", value: "2" },
  { id: "3", label: "3", value: "3" },
  { id: "4", label: "4", value: "4" },
  { id: "5", label: "5", value: "5" },
  { id: "6", label: "6", value: "6" },
  { id: "7", label: "7", value: "7" },
  { id: "8", label: "8", value: "8" },
  { id: "9", label: "9", value: "9" },
  { id: "10", label: "10", value: "10" },
];

// export const ASSET_ICON_TYPES_VALUES =

export enum ASSET_ICON_TYPES {
  STATUS_BASED = "status_icon",
  STANDARD_ICON = "standard_icon",
  CUSTOM_IMAGE = "custom_image",
}

export const ASSET_ICON_TYPE_OPTIONS = [
  {
    value: ASSET_ICON_TYPES.STATUS_BASED,
    label: "Status based icon (Default)",
  },
  { value: ASSET_ICON_TYPES.STANDARD_ICON, label: "Standard icon" },
  { value: ASSET_ICON_TYPES.CUSTOM_IMAGE, label: "Custom Image" },
];

export const STANDARD_ICONS_SLUGS = {
  ICON_FORKLIFT_TRUCK: "1",
  ICON_EXCAVATOR: "2",
  ICON_VAN: "3",
  ICON_PICKUP_TRUCK: "4",
  ICON_TRAILER: "5",
  ICON_SANITATION_TRUCK: "6",
  ICON_EV: "7",
  ICON_TRACTOR: "8",
  ICON_TOW_TRUCK: "9",
  ICON_SKID_STEER: "10",
  ICON_CONCRETE_TRUCK: "11",
  ICON_BUS_FRONT: "12",
  ICON_BUS_SIDE: "13",
  ICON_CAR_SIDE: "14",
  ICON_CAR_FRONT: "15",
  ICON_BACKHOE: "16",
  ICON_BUCKET_TRUCK_OPEN: "17",
  ICON_BUCKET_TRUCK_CLOSED: "18",
  ICON_EIGHTEEN_WHEELER_TRUCK: "19",
  ICON_BULLDOZER: "20",
};

export const STANDARD_ICONS_LIST = [
  {
    key: STANDARD_ICONS_SLUGS.ICON_FORKLIFT_TRUCK,
    name: "ICON_FORKLIFT_TRUCK",
    icon: svgIcons.ForkliftTruck,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_EXCAVATOR,
    name: "ICON_EXCAVATOR",
    icon: svgIcons.Excavator,
  },
  { key: STANDARD_ICONS_SLUGS.ICON_VAN, name: "ICON_VAN", icon: svgIcons.Van },
  {
    key: STANDARD_ICONS_SLUGS.ICON_PICKUP_TRUCK,
    name: "ICON_PICKUP_TRUCK",
    icon: svgIcons.PickupTruck,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_TRAILER,
    name: "ICON_TRAILER",
    icon: svgIcons.Trailer,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_SANITATION_TRUCK,
    name: "ICON_SANITATION_TRUCK",
    icon: svgIcons.SanitationTruck,
  },
  { key: STANDARD_ICONS_SLUGS.ICON_EV, name: "ICON_EV", icon: svgIcons.EV },
  {
    key: STANDARD_ICONS_SLUGS.ICON_TRACTOR,
    name: "ICON_TRACTOR",
    icon: svgIcons.Tractor,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_TOW_TRUCK,
    name: "ICON_TOW_TRUCK",
    icon: svgIcons.TowTruck,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_SKID_STEER,
    name: "ICON_SKID_STEER",
    icon: svgIcons.SkidSteer,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_CONCRETE_TRUCK,
    name: "ICON_CONCRETE_TRUCK",
    icon: svgIcons.ConcreteTruck,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_BUS_FRONT,
    name: "ICON_BUS_FRONT",
    icon: svgIcons.BusFront,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_BUS_SIDE,
    name: "ICON_BUS_SIDE",
    icon: svgIcons.BusSide,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_CAR_SIDE,
    name: "ICON_CAR_SIDE",
    icon: svgIcons.CarSide,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_CAR_FRONT,
    name: "ICON_CAR_FRONT",
    icon: svgIcons.CarFront,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_BACKHOE,
    name: "ICON_BACKHOE",
    icon: svgIcons.Backhoe,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_BUCKET_TRUCK_OPEN,
    name: "ICON_BUCKET_TRUCK_OPEN",
    icon: svgIcons.BucketTruckOpen,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_BUCKET_TRUCK_CLOSED,
    name: "ICON_BUCKET_TRUCK_CLOSED",
    icon: svgIcons.BucketTruckClosed,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_EIGHTEEN_WHEELER_TRUCK,
    name: "ICON_EIGHTEEN_WHEELER_TRUCK",
    icon: svgIcons.EighteenWheelerTruck,
  },
  {
    key: STANDARD_ICONS_SLUGS.ICON_BULLDOZER,
    name: "ICON_BULLDOZER",
    icon: svgIcons.Bulldozer,
  },
];
